const sampleClient = (user: any) => ({
  id: 1 as any,
  title: "Sample Client",
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  incomes: [],
  people: [
    {
      name: "Person 1",
      birthday: new Date("1965-01-01").toISOString(),
      id: 0,
    },
    {
      name: "Person 2",
      birthday: new Date("1975-01-01").toISOString(),
      id: 1,
    },
  ],
  scenarios: [
    {
      id: 123312,
      name: "Household Plan",
      clientId: 1 as any,
      inflation: 2.5,
      whoDies: -1,
      incomes: [
        {
          id: 1,
          stable: false,
          enabled: true,
          type: "employment-income",
          personId: 0,
          annualIncome: 15000,
          startAge: null,
          firstYearProratePercent: 100,
          yearlyIncreasePercent: null,
          yearlyIncrease: { type: "general" },
          retirementAgeYear: null,
          retirementAgeMonth: null,
          taxType: "Taxable",
          start: { type: "already-receiving" },
          end: { type: "retirement", personId: 0 },
        },
      ],
      deathYears: [74, 76],
      retirementYears: [73, 74],
      preTaxRate: 20,
      postTaxRate: 30,
    },
  ],
  tasks: [],
  scenarioOrder: [123312],
  needsFlag: !!user?.info?.needsFlag,
  stabilityRatioFlag: !!user?.info?.stabilityRatioFlag,
  longevityFlag: !!user?.info?.longevityFlag,
  taxesFlag: !!user?.info?.taxesFlag,
  assetSummary: {} as any,
  spending: {
    preTaxRate: user?.info?.globalPreRetirementTaxRate,
    postTaxRate: user?.info?.globalPostRetirementTaxRate,
    retirementYear: 2030,
    preSpending: [],
    postSpending: [],
    yearlyIncrease: { type: "general" },
    newCurrentSpending: { type: "yearly" as const, value: 0 },
    currentSpending: 12000,
    decreaseAtDeath: [0, 0],
  },
  allInOneCalculator: [],
  annuityRoRCalculators: [
    {
      id: Math.round(Math.random() * 10e10),
      name: "Scenario 1",
    },
  ],
  equivalentYieldCalculator: {} as any,
  safeWdCalculator: {} as any,
  versatileCalculators: [
    {
      id: Math.round(Math.random() * 10e10),
      name: "Scenario 1",
    },
  ],
  liveSettings: {
    id: -1,
    name: "",
    inflation: user?.info?.globalInflation,
    maxYearsShown: 20,
    whoDies: -1,
    taxType: "Pre",
    inflationType: "Nominal",
    incomes: [],
    people: [],
    longevityPercent: 50,
    chartType: "income",
    chartFirst: false,
    showTaxType: false,
    mapPage: "income",
    deathYears: [
      user?.info?.globalLifeExpectancy,
      user?.info?.globalLifeExpectancy,
    ],
    retirementYears: [null, null],
    mapType: "all incomes",
    monthlyYearly: "yearly",
    preTaxRate: user?.info?.globalPreRetirementTaxRate,
    postTaxRate: user?.info?.globalPostRetirementTaxRate,
  },
  reportSettings: user?.info?.globalReportSettings || [],
  notes: "",
});

export default sampleClient;
